export const CHALLENGE_STATUSES = {
  Waiting: 'Waiting for opponent',
  Accepted: 'Accepted',
  Retracted: 'Canceled',
  Expired: 'Expired',
  Finished: 'Completed',
} as const;

export const DEBATE_STATUSES = {
  Scheduled: 'Scheduled',
  InProgress: 'Live',
  Failed: 'Canceled',
  Deleted: 'Deleted',
  Finished: 'Completed',
} as const;
